import { DataGridTypes } from 'devextreme-react/cjs/data-grid';
import { DataGridCell } from 'devextreme/common/export/excel';
import { theme } from 'core/Theming/theme';
import { ActiveWebUsageReport } from 'api/resources/models/AutoGenerated';

export const valuesConverter = (data: ActiveWebUsageReport[]) => {
  return data.map((row) => {
    return {
      ...row,
      accountLockedDate: row.accountLockedDate ? 'TRUE' : 'FALSE',
      disabled: `${row.disabled?.toString()?.toUpperCase()}`,
    };
  });
};

export const cellPrepared = (e: DataGridTypes.CellPreparedEvent) => {
  if (e.rowType === 'data') {
    if (e?.data?.disabled === 'TRUE') {
      e.cellElement.classList.add('pink');
    }
  }
};

export const customizeCell = ({
  gridCell,
  excelCell,
}: {
  gridCell?: DataGridCell;
  excelCell?: any;
}) => {
  if (gridCell?.rowType === 'data') {
    if (gridCell?.data?.disabled === 'TRUE') {
    excelCell.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: {
        argb: theme.palette.reports.pink?.replace('#', ''),
      },
    };
    }
  }
};
